import { render, staticRenderFns } from "./IdCardLanyardIcon.vue?vue&type=template&id=653c70fa"
import script from "./IdCardLanyardIcon.vue?vue&type=script&lang=js"
export * from "./IdCardLanyardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports